import React, {FC, useEffect, useState} from 'react';
import {ProductBadge, ProductImage, ProductVideo} from '__generated__/__types__';
import {ThumbCarouselHandler} from '@/_application/core/components/ui/thumb-carousel/thumb-carousel-handler';
import {CloseIcon} from '@/_application/icons/close-icon';
import {useModalState} from '@/_application/core/components/ui/modal/modal.context';
import {useIsMobileDevice} from '@/_application/core/hooks/useIsMobileDevice';
import {SwiperClass} from 'swiper/react';
import {Product} from '@/_application/modules/products/model/product';
interface Props {
    gallery: (ProductImage | ProductVideo)[];
    badge?: ProductBadge;
    product: Product;
}

export const ThumbsCarousel: FC<Props> = ({badge, gallery, product}) => {
    const [currentSlide, setCurrentSlide] = useState<number>(0);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const {isOpen: isPopup} = useModalState();
    const [mainSwiper, setMainSwiper] = useState<SwiperClass | undefined>();

    const onOpenZoomModal = () => {
        if (isPopup) return;
        setOpenModal(true);
    };

    const onCloseZoomModal = () => {
        setOpenModal(false);
    };

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && openModal) {
                onCloseZoomModal();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, onCloseZoomModal]);

    useEffect(() => {
        mainSwiper?.slideTo(currentSlide);
    }, [currentSlide]);

    const isMobile = useIsMobileDevice();
    const [isClientReady, setIsClientReady] = useState(false);

    useEffect(() => {
        setIsClientReady(true);
    }, []);
    if (!isClientReady) return null;
    const showThumbNailsOutside = !isMobile && gallery.length > 1;
    const showThumbNailsInside = gallery.length > 1;

    return (
        <div className="relative">
            <ThumbCarouselHandler
                gallery={gallery}
                onImageClick={onOpenZoomModal}
                showThumbNails={showThumbNailsOutside}
                onSlideChange={setCurrentSlide}
                currentSlide={currentSlide}
                onMainSwiper={setMainSwiper}
                badge={badge}
                hoverZoomMode={!openModal}
                product={product}
            />

            {openModal && (
                <div className="fixed inset-0 z-[400] flex justify-center items-center bg-black/50 backdrop-blur-sm">
                    <div
                        className={`
                        relative bg-white rounded-lg shadow-xl
                        ${isMobile ? 'w-full h-full rounded-none' : 'min-w-[50%] max-w-[70%] min-h-[80vh]'}
                        `}>
                        <button
                            aria-label="Đóng chế độ phóng to"
                            onClick={onCloseZoomModal}
                            className="absolute right-5 top-5 z-50 flex h-8 w-8 items-center justify-center rounded-full border border-primary text-primary bg-white">
                            <CloseIcon className="h-5 w-5" />
                        </button>
                        <ThumbCarouselHandler
                            gallery={gallery}
                            onSlideChange={setCurrentSlide}
                            currentSlide={currentSlide}
                            zoomMode={true}
                            hoverZoomMode={false}
                            product={product}
                            showThumbNails={showThumbNailsInside}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
